module.exports = __webpack_public_path__ + "img/bot_bg.13ffcf88.webp";